<template>
  <div>
    <template v-if="isKyc">
      <p class="has-text-weight-bold is-size-4 mb-1">
        {{ $t("mp:application.kyc.title") }}
      </p>
      <p class="mb-5">{{ $t("mp:application.kyc.subtitle") }}</p>

      <div class="is-flex is-align-items-center mb-4">
        <b-icon
          icon-pack="fa"
          icon="check-circle"
          type="is-green"
          class="mr-2"
        ></b-icon>

        <span class="has-text-weight-medium has-text-green">{{
          $t("mp:application.kyc.label.operator_available")
        }}</span>
      </div>
    </template>
    <template v-else>
      <p class="has-text-weight-bold is-size-4 mb-1">
        {{ $t("mp:application.sign.title") }}
      </p>
      <p class="mb-5">{{ $t("mp:application.sign.subtitle") }}</p>

      <div class="is-flex is-align-items-center mb-4">
        <b-icon
          icon-pack="fa"
          icon="check-circle"
          type="is-green"
          class="mr-2"
        ></b-icon>

        <span class="has-text-weight-medium has-text-green">{{
          $t("mp:application.sign.label.operator_available")
        }}</span>
      </div>
    </template>

    <p class="mb-5">{{ $t("mp:application.video_call.title") }}</p>

    <div class="devices">
      <div class="device">
        <div class="device__tile" @click="goMobile">
          <b-icon
            icon-pack="fa"
            icon="mobile"
            type="is-grey-icon"
            size="is-large"
          ></b-icon>

          <span class="has-text-centered is-size-7 has-text-grey-icon">{{
            $t("mp:application.video_call.label.mobil")
          }}</span>
        </div>

        <p class="has-text-centered is-size-7 has-text-grey-icon">
          {{ $t("mp:application.video_call.label.mobil.footer") }}
        </p>
      </div>
      <div class="device">
        <div class="device__tile" @click="goDesktop">
          <b-icon
            icon-pack="fa"
            icon="desktop"
            type="is-grey-icon"
            size="is-large"
          ></b-icon>

          <span class="has-text-centered is-size-7 has-text-grey-icon">{{
            $t("mp:application.video_call.label.this_device")
          }}</span>
        </div>

        <p class="has-text-centered is-size-7 has-text-grey-icon">
          {{ $t("mp:application.video_call.label.this_device.footer") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ApplicationFlowKYCChoose",
  props: {
    position: {
      type: String,
      required: true,
    },
  },
  computed: {
    isKyc() {
      return this.position.includes("KYC");
    },
  },
  methods: {
    ...mapActions({
      savePosition: "application/savePosition",
    }),
    async goMobile() {
      this.$store.dispatch("application/setSignMobile", true); // client-side setters
      this.$store.dispatch("application/setKycMobile", true);
      if (this.isKyc) {
        await this.$store.dispatch("application/startKyc");
      } else {
        await this.$store.dispatch("application/startSign");
      }
    },
    async goDesktop() {
      this.$store.dispatch("application/setSignMobile", false);
      this.$store.dispatch("application/setKycMobile", false);
      if (this.isKyc) {
        await this.$store.dispatch("application/startKyc");
      } else {
        await this.$store.dispatch("application/startSign");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.devices {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
  grid-auto-flow: column;

  .device {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: start;

    &__tile {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 1px solid #dfe6ef;
      border-radius: 16px;
      padding: 24px;
      cursor: pointer;
      margin-bottom: 1rem;

      .icon {
        font-size: 1.5rem;
        height: 4rem;
        width: 4rem;
      }
    }
  }
}
</style>
